import { BridgeConfig } from './model/bridge-config';
import BridgeError from './model/bridge-error';
import ChildBridge from './child-bridge';
import ParentBridge from './parent-bridge';
// eslint-disable-next-line import/prefer-default-export
export { BridgeError, ChildBridge, ParentBridge };

export type { BridgeConfig };
